app.filter('linkify', ['$sce', function ($sce) {
    return function (input) {
        if (!input) return input;

        // Regular expression to detect URLs with http, https, and www
        var urlPattern = /(\b(https?:\/\/|www\.)[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

        // Replace URLs with anchor tags
        var replacedText = input.replace(urlPattern, function (url) {
            // If the URL starts with 'www.', add 'https://' to the URL
            var href = url;
            if (url.indexOf('www.') === 0) {
                href = 'https://' + url;
            }
            return '<a href="' + href + '" target="_blank">' + url + '</a>';
        });

        // Mark the string as trusted HTML to avoid Angular's sanitization
        return $sce.trustAsHtml(replacedText);
    };
}]);
